import request from '@/utils/request'

export function add(data) {
    return request({
        url: '/sysScheduledTaskConfiguration',
        method: 'post',
        data
    })
}

export function implement(id) {
    return request({
        url: '/sysScheduledTaskConfiguration/implement/' + id,
        method: 'get'
    })
}

export function del(id) {
    return request({
        url: '/sysScheduledTaskConfiguration/' + id,
        method: 'delete'
    })
}

/**
 * 启用禁用
 * @param id
 * @param status 0禁用，1启用
 */
export function enableOrDisable(id, status) {
    return request({
        url: `/sysScheduledTaskConfiguration/enableOrDisable/${id}/${status}`,
        method: 'get'
    })
}

